module.exports = __webpack_public_path__ + "media/tip.97e7e356.mp3";